import React from 'react'
import PropTypes from 'prop-types'

import { memo } from 'utils/react'
import { AccordionDetails, IconButton, Typography, Divider } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { grey } from '@mui/material/colors'

import { AccordionSummary } from 'components/common/HHAccordion'
import { StyledAccordion } from './StyledAccordion'

const MonthAccordion = ({ isExpanded = false, month, onChange, children }) => {
  return (
    <StyledAccordion
      expanded={isExpanded}
      elevation={0}
      disablePointer
      onChange={onChange}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary
        sx={{ border: 0, background: grey[50] }}
        expandIcon={
          <IconButton>
            <ChevronRightIcon />
          </IconButton>
        }
      >
        <Typography variant="h6" fontWeight={400}>
          {month}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Divider />
        {children}
      </AccordionDetails>
    </StyledAccordion>
  )
}

MonthAccordion.propTypes = {
  isExpanded: PropTypes.bool,
  month: PropTypes.number,
  onChange: PropTypes.func,
  children: PropTypes.node,
}

export default memo(MonthAccordion)
